export enum SciTheme {
  SCI = 'sci',
  PayForU = 'payforu',
  Light = 'light',
  SQ = 'sq',
}

export type UppyDialogTheme = 'light' | 'dark' | 'auto';

export const SciThemeToUppyDialogMap: Record<SciTheme, UppyDialogTheme> = {
  [SciTheme.SCI]: 'dark',
  [SciTheme.PayForU]: 'dark',
  [SciTheme.Light]: 'light',
  [SciTheme.SQ]: 'light',
};
